/* eslint-disable @typescript-eslint/explicit-function-return-type */
import styled from 'styled-components';
import { typography } from '@everlywell/leaves';

import { ariesTheme } from 'styles/ariesTheme';

const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-weight: ${typography.weight.regular};

  position: relative;
  box-sizing: border-box;
  border-bottom: 1px solid
    rgb(
      ${props =>
        props.theme.defaultBorderColor || ariesTheme.defaultBorderColor}
    );
  padding: 24px 0;

  transition: background-color 0.2s, opacity 0.2s;

  &__thumb {
    vertical-align: middle;
    width: 15%;
    margin-right: 3%;

    img {
      width: 100%;
      height: auto;
    }
  }
`;

const SelectQuantity = styled.div`
  position: relative;
  background-color: rgb(${props => props.theme.white || ariesTheme.white});
  width: 55px;
  height: 24px;
  border-radius: 12px;
  border: 1px solid
    rgb(
      ${props =>
        props.theme.defaultBorderColor || ariesTheme.defaultBorderColor}
    );
  max-width: 100%;
  display: flex;
  cursor: pointer;
  select {
    cursor: pointer;
    display: flex;
    width: 100%;
    max-width: 100%;
    font-size: 14px;
    margin: 0;
    line-height: normal;
    color: rgb(
      ${props =>
        props.theme.quaternaryTextColor || ariesTheme.quaternaryTextColor}
    );
    padding-left: 12px;
    border: none;
    background-color: transparent;
    appearance: none;
    font-family: ${typography.type.nexa};
    &:active,
    &:focus {
      outline: none;
      box-shadow: none;
    }
  }
  &:after {
    cursor: pointer;
    pointer-events: none;
    border-style: solid;
    border-width: 0px 0px 2px 2px;
    border-color: rgb(
      ${props =>
        props.theme.countPickerBorderColor || ariesTheme.countPickerBorderColor}
    );
    content: '';
    display: inline-block;
    position: absolute;
    top: 6px;
    right: 10px;
    width: 5px;
    height: 5px;
    box-sizing: content-box;
    transform: rotate(-45deg);
  }
`;

const ItemDetailsWrapper = styled.div`
  display: flex;
  width: 100%;
`;

const ItemDetails = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-left: 12px;
  color: rgb(
    ${props => props.theme.primaryTextColor || ariesTheme.primaryTextColor}
  );
  font-size: 18px;
  font-weight: ${typography.weight.bold};
  line-height: 1.67;
  letter-spacing: 0.7px;
`;

const Bottom = styled.div`
  display: flex;
  justify-content: space-between;
  color: rgb(
    ${props =>
      props.theme.quaternaryTextColor || ariesTheme.quaternaryTextColor}
  );
  margin: 0;
  font-size: 14px;
`;

const ImgPlaceholder = styled.div`
  width: 100px;
  height: 58px;
  background-color: rgb(
    ${props => props.theme.defaultBorderColor || ariesTheme.defaultBorderColor}
  );
  display: flex;
  justify-content: center;
  align-items: center;
  color: gray;
  font-size: 10px;
`;

const ProductImage = styled.div`
  min-width: 100px;
  width: 100px;
  height: 64px;
`;

const ItemPrice = styled.div`
  color: rgb(
    ${props =>
      props.theme.quaternaryTextColor || ariesTheme.quaternaryTextColor}
  );
  font-weight: ${typography.weight.bold};
`;

const RemoveBtn = styled.div`
  cursor: pointer;
  font-weight: ${typography.weight.regular};
  letter-spacing: 0.09px;
`;

const ItemSubscription = styled.div`
  font-weight: ${typography.weight.regular};
  font-size: 14px;
  line-height: 1.71;
  letter-spacing: 0.09px;
  align-self: flex-end;
  color: rgb(
    ${props => props.theme.primaryInfoColor || ariesTheme.primaryInfoColor}
  );
`;

export {
  ProductInfo,
  RemoveBtn,
  ItemDetailsWrapper,
  ItemDetails,
  ProductImage,
  ItemPrice,
  ItemSubscription,
  Bottom,
  ImgPlaceholder,
  SelectQuantity,
};
